import { Typography } from "@p0security/ui";
import { Link } from "react-router-dom";

import { awsAccessLogsInstaller } from "./access-logs";
import { awsFunctionCallerInstaller } from "./function-caller";
import { awsIamAssessmentInstaller } from "./iam-assessment";
import { awsIamWriteInstaller } from "./iam-write";
import { awsInventoryInstaller } from "./inventory";
import { rdsSecurityPerimeterInstaller } from "./security-perimeter";
import type { AwsInstaller } from "./types";

export const awsInstaller: AwsInstaller = {
  components: {
    base: { items: {} },
    "iam-assessment": awsIamAssessmentInstaller,
    "iam-write": awsIamWriteInstaller,
    inventory: awsInventoryInstaller,
    "function-caller": awsFunctionCallerInstaller,
    "rds-security-perimeter": rdsSecurityPerimeterInstaller,
    "access-logs": awsAccessLogsInstaller,
  },
  preamble: (
    <>
      <Typography.Paragraph>
        Connect AWS to enable IAM management and resource-level access control
        for your AWS accounts.
      </Typography.Paragraph>
      <Typography.Text strong>
        Recommended components by use case:
      </Typography.Text>
      <ul className="preamble-list">
        <li>
          <strong>Just-in-time access:</strong>{" "}
          <Link to="./iam-write">IAM Management</Link>, and optionally{" "}
          <Link to="./inventory">Resource Inventory</Link> and{" "}
          <Link to="./access-logs">Access Logging</Link>
        </li>
        <li>
          <strong>Inventory and Posture:</strong>{" "}
          <Link to="./iam-assessment">IAM Assessment</Link> and{" "}
          <Link to="./inventory">Resource Inventory</Link>
        </li>
        <li>
          <strong>Custom notifiers:</strong>{" "}
          <Link to="./function-caller">Function Invocation</Link>
        </li>
      </ul>
    </>
  ),
};
